/**
 * useCancelInvitation Hook
 *
 * React Query mutation hook for cancelling an invitation.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { userService } from '../../../api/user.service';
import { getErrorMessage } from '../../../lib/utils/errors';

/**
 * Hook for cancelling an invitation
 */
export const useCancelInvitation = (
  tenantId: string
): UseMutationResult<{ message: string }, Error, string> => {
  const queryClient = useQueryClient();

  return useMutation<{ message: string }, Error, string>({
    mutationFn: (invitationId) => {
      console.log('[useCancelInvitation] Cancelling invitation:', invitationId);
      return userService.cancelInvitation(tenantId, invitationId);
    },
    onSuccess: (_, invitationId) => {
      console.log('[useCancelInvitation] Invitation cancelled successfully:', invitationId);
      // Invalidate invitations list to refresh the data
      queryClient.invalidateQueries({ queryKey: ['invitations', tenantId] });
    },
    onError: (error) => {
      console.error('[useCancelInvitation] Failed to cancel invitation:', getErrorMessage(error));
    },
  });
};
